import { useEffect, useState } from "react";
import { Check, Minus } from "lucide-react";
import { useI18n } from "../../../i18n";
import { api } from "../../../lib/api";
import { RoleBadge } from "../../../components/common/RoleBadge";

const STAFF = ["admin", "executive", "accounting", "customer_service", "sales_rep", "warehouse", "driver", "employee"];
const CUSTOMER = ["customer_admin", "customer_ordering"];

const Matrix = ({ roles, matrix, perms }) => {
  const { t } = useI18n();
  return (
    <div className="overflow-x-auto rounded-2xl bg-white shadow-sm">
      <table className="w-full min-w-[720px] text-sm">
        <thead><tr className="border-b border-slate-100"><th className="sticky left-0 bg-white p-3 text-left text-xs font-semibold text-slate-500">{t("x.perm.permission")}</th>
          {roles.map((r) => <th key={r} className="p-2 text-center"><RoleBadge role={r} /></th>)}</tr></thead>
        <tbody>
          {perms.map((p) => (
            <tr key={p} className="border-b border-slate-50 hover:bg-canvas" data-testid={`perm-row-${p}`}>
              <td className="sticky left-0 bg-white p-3"><p className="font-medium text-navy">{t(`x.perm.p.${p.replace(":", "_")}`)}</p><p className="font-mono text-[10px] text-slate-400">{p}</p></td>
              {roles.map((r) => {
                const on = matrix[r]?.includes("*") || matrix[r]?.includes(p);
                return <td key={r} className="p-2 text-center">{on ? <Check className="mx-auto h-4 w-4 text-brand-ink" aria-label="yes" /> : <Minus className="mx-auto h-4 w-4 text-slate-200" aria-label="no" />}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default function Permissions() {
  const { t } = useI18n();
  const [matrix, setMatrix] = useState(null);
  useEffect(() => {
    api.get("/admin/users/roles").then((r) => setMatrix(r.data)).catch(() => setMatrix({}));
  }, []);
  if (!matrix) return null;
  const perms = (roles) => [...new Set([...roles.flatMap((r) => matrix[r] || []), ...(roles.includes("admin") ? ["users:manage", "softone:admin"] : [])])].filter((p) => p !== "*").sort();
  return (
    <div className="space-y-6" data-testid="permissions-page">
      <div>
        <h1 className="text-3xl font-bold text-navy sm:text-4xl">{t("x.perm.title")}</h1>
        <p className="mt-2 text-sm text-slate-500">{t("x.perm.sub")}</p>
      </div>
      <section className="space-y-2"><h2 className="text-base font-semibold text-navy md:text-lg">{t("x.perm.staff")}</h2><Matrix roles={STAFF} matrix={matrix} perms={perms(STAFF)} /></section>
      <section className="space-y-2"><h2 className="text-base font-semibold text-navy md:text-lg">{t("x.perm.customer")}</h2><Matrix roles={CUSTOMER} matrix={matrix} perms={perms(CUSTOMER)} /></section>
    </div>
  );
}
